import { DocstoreSections } from "../../../../../model";
import { DataType } from "../../docstore-section-table/model/types";

// Базовые фильтры для большинства секций
const baseFilters = [
  "Номер документа",
  "Дата выдачи",
  "Орг. выдавшая док.",
  "Автор",
  "Организация автора",
];

// Фильтры для разрешительной документации
const permitsFilters = [
  "Номер документа",
  "Дата выдачи",
  "Орг. выдавшая док.",
  "Автор",
  "Организация автора",
];

// Фильтры для проектной документации
const projectFilters = [
  "Номер документа",
  "Дата выдачи",
  "Орг. выдавшая док.",
  "Автор",
  "Организация автора",
];

// Фильтры для рабочей документации
const workFilters = [
  "Номер документа",
  "Дата выдачи",
  "Орг. выдавшая док.",
  "Автор",
  "Организация автора",
];

// Фильтры для исполнительных схем
const executiveSchemesFilters = [
  "Номер документа",
  "Дата выдачи",
  "Орг. выдавшая док.",
  "Автор",
  "Организация автора",
];

// Фильтры для исполнительных чертежей
const executiveDrawingsFilters = [
  "Дата выдачи",
  "Шифр",
  "Орг. выдавшая док.",
  "Автор",
  "Организация автора",
];

// Фильтры для документов подтверждающих качество
const qualityConfirmationFilters = [
  "Номер документа",
  "Вид ДПК",
  "Дата выдачи",
  "Срок действия",
  "Орг. выдавшая док.",
  "Автор",
  "Организация автора",
];

// Фильтры для лабораторий
const laboratoriesFilters = [
  "Номер документа",
  "Дата выдачи",
  "Орг. выдавшая док.",
  "Автор",
  "Организация автора",
];

// Фильтры для сопроводительных документов
const accompanyingDocumentsFilters = [
  "Номер документа",
  "Дата выдачи",
  "Орг. выдавшая док.",
  "Автор",
  "Организация автора",
];

// Фильтры для нормативной документации (только поиск)
const normativeDocumentsFilters: string[] = [];

// Конфигурация фильтров для каждой секции
export const sectionFiltersConfig: Record<
  (typeof DocstoreSections)[keyof typeof DocstoreSections],
  string[]
> = {
  [DocstoreSections.PERMITS]: permitsFilters,
  [DocstoreSections.WORKING_DRAFT]: projectFilters,
  [DocstoreSections.WORK]: workFilters,
  [DocstoreSections.EXECUTIVE_SCHEME]: executiveSchemesFilters,
  [DocstoreSections.EXECUTIVE_DRAWING]: executiveDrawingsFilters,
  [DocstoreSections.CERTIFICATE]: qualityConfirmationFilters,
  [DocstoreSections.LABORATORY_DATA]: laboratoriesFilters,
  [DocstoreSections.SUPPORTING]: accompanyingDocumentsFilters,
  [DocstoreSections.NORMATIVE]: normativeDocumentsFilters,
  [DocstoreSections.TRASH]: baseFilters,
};

// Маппинг названий фильтров на поля данных
export const filterFieldMapping: Record<string, string> = {
  "Номер документа": "docNumber",
  "Дата выдачи": "date",
  "Орг. выдавшая док.": "issuer",
  Автор: "author.name",
  "Организация автора": "author.org",
  Шифр: "code",
  "Вид ДПК": "docType",
  "Срок действия": "expiryDate",
};

export const getFieldValue = (item: DataType, fieldPath: string): string => {
  const value = fieldPath.split(".").reduce<unknown>((acc, part) => {
    if (acc === undefined || acc === null) {
      return undefined;
    }

    return (acc as Record<string, unknown>)[part];
  }, item);

  if (value === undefined || value === null) {
    return "";
  }

  return String(value);
};

export const getSearchableValues = (item: DataType): string[] => {
  return [
    item?.docNumber,
    item?.date,
    item?.issuer,
    item?.stamps?.map(stamp => `${stamp.name} ${stamp.status}`).join(' '),
    item?.page,
    item?.workDraw,
    item?.code,
    item?.expiryDate,
    item?.producer,
    item?.fullName?.name,
    item?.fullName?.description,
    item?.docName?.name,
    item?.docName?.description,
    item?.author?.name,
    item?.author?.org,
  ].filter((value): value is string => typeof value === 'string' && value.trim() !== '');
};
